import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../shared/Modal'

const BODY_TEXT_CLASS = 'tw:m-0! tw:text-sm tw:text-gray-700'

const ConfirmRemovePhotoModal = ({ isOpen, onCancel, onConfirm }) => {
  const footer = (
    <>
      <button className="btn btn-light border" type="button" onClick={onCancel}>
        Annuler
      </button>
      <button className="btn btn-danger" type="button" onClick={onConfirm}>
        Supprimer
      </button>
    </>
  )

  return (
    <Modal footer={footer} isOpen={isOpen} title="Supprimer la photo ?" onClose={onCancel}>
      <p className={BODY_TEXT_CLASS}>
        Cette photo sera définitivement retirée lors de l’enregistrement de l’alerte.
      </p>
    </Modal>
  )
}

ConfirmRemovePhotoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ConfirmRemovePhotoModal
